// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.withdrawing-page {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.withdrawing-page .spring-on-background{
    position: absolute;
    z-index: -1;
    top: 22vw;
    right: 0;
    width: 83.721vw;
    height: 80.07vw;
}


.withdrawing-page .withdrawing-page-title {
    font-weight: 600;
    font-size: 5.581vw;
    line-height: 6.512vw;
    letter-spacing: 2%;
    text-align: center;
    color: white;
}

.withdrawing-page .middle-content {
    padding: 0 9vw;
}
.withdrawing-page .bottom-content{
    margin-bottom: 9vw;
}


.withdrawing-page .middle-content h3{
    margin-bottom: 4.651vw;
}

.withdrawing-page .middle-content .withdrawing-button h3{
    margin-bottom: 0;
    margin-right: 0.698vw;
}

.button-row {
    display: flex;
    justify-content: space-between;
}

.withdrawing-button {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.5px solid #FFFFFF;
    background-color: #1C1C1D;
    border-radius: 9px;
    width: 24.884vw;
    height: 11.395vw;
}

.withdrawing-button img{
    width: 4.419vw;
    height: 4.419vw;
}


.link-button {
    display: flex;
    align-items: center;
    background-color: #1C1C1D;
    width: 86.512vw;
    height: 10.233vw;
    border-radius: 15px;
    margin: 1.163vw auto;
}


.withdrawing-page .bottom-content .link-button .button-text{
    font-family: Roboto;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.4px;
    color: white;
}

.link-button .leading-icon{
    width: 6.744vw;
    height: 6.744vw;
    margin: 0 3.488vw;
}

.link-button .tale-icon{
    width: 1.628vw;
    height: 2.791vw;
    margin-left:  auto;
    margin-right: 3.488vw;
}


.link-button {
    display: flex;
    align-items: center;
  }
  
  .button-text {
    margin-right: 10px; /* Додає відступ між текстом і кнопкою */
  }
  
  .button-container {
    display: flex;
    align-items: center;
  }
  
  .confirm-button {
    background-color: #007BFF; /* Колір кнопки */
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .tale-icon {
    margin-left: 10px; /* Відступ для іконки стрілки */
  }
  
  .confirm-button:hover {
    background-color: #0056b3; /* Зміна кольору при наведенні */
  }`, "",{"version":3,"sources":["webpack://./src/pages/withdrawing/style/withdrawing_page.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB,EAAE,wCAAwC;EAC9D;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB,EAAE,iBAAiB;IAC5C,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB,EAAE,+BAA+B;EACpD;;EAEA;IACE,yBAAyB,EAAE,gCAAgC;EAC7D","sourcesContent":[".withdrawing-page {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n}\n\n.withdrawing-page .spring-on-background{\n    position: absolute;\n    z-index: -1;\n    top: 22vw;\n    right: 0;\n    width: 83.721vw;\n    height: 80.07vw;\n}\n\n\n.withdrawing-page .withdrawing-page-title {\n    font-weight: 600;\n    font-size: 5.581vw;\n    line-height: 6.512vw;\n    letter-spacing: 2%;\n    text-align: center;\n    color: white;\n}\n\n.withdrawing-page .middle-content {\n    padding: 0 9vw;\n}\n.withdrawing-page .bottom-content{\n    margin-bottom: 9vw;\n}\n\n\n.withdrawing-page .middle-content h3{\n    margin-bottom: 4.651vw;\n}\n\n.withdrawing-page .middle-content .withdrawing-button h3{\n    margin-bottom: 0;\n    margin-right: 0.698vw;\n}\n\n.button-row {\n    display: flex;\n    justify-content: space-between;\n}\n\n.withdrawing-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 0.5px solid #FFFFFF;\n    background-color: #1C1C1D;\n    border-radius: 9px;\n    width: 24.884vw;\n    height: 11.395vw;\n}\n\n.withdrawing-button img{\n    width: 4.419vw;\n    height: 4.419vw;\n}\n\n\n.link-button {\n    display: flex;\n    align-items: center;\n    background-color: #1C1C1D;\n    width: 86.512vw;\n    height: 10.233vw;\n    border-radius: 15px;\n    margin: 1.163vw auto;\n}\n\n\n.withdrawing-page .bottom-content .link-button .button-text{\n    font-family: Roboto;\n    font-weight: 400;\n    font-size: 17px;\n    line-height: 22px;\n    letter-spacing: -0.4px;\n    color: white;\n}\n\n.link-button .leading-icon{\n    width: 6.744vw;\n    height: 6.744vw;\n    margin: 0 3.488vw;\n}\n\n.link-button .tale-icon{\n    width: 1.628vw;\n    height: 2.791vw;\n    margin-left:  auto;\n    margin-right: 3.488vw;\n}\n\n\n.link-button {\n    display: flex;\n    align-items: center;\n  }\n  \n  .button-text {\n    margin-right: 10px; /* Додає відступ між текстом і кнопкою */\n  }\n  \n  .button-container {\n    display: flex;\n    align-items: center;\n  }\n  \n  .confirm-button {\n    background-color: #007BFF; /* Колір кнопки */\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    cursor: pointer;\n    border-radius: 4px;\n  }\n  \n  .tale-icon {\n    margin-left: 10px; /* Відступ для іконки стрілки */\n  }\n  \n  .confirm-button:hover {\n    background-color: #0056b3; /* Зміна кольору при наведенні */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
